import React from "react";
import TextView from "../../TextView";
import { Box } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { motion } from "framer-motion";

const ReportOptions = ({ options, onSelectOption, path }) => {
  return (
    <>
      {path.length === 0 && (
        <>
          <TextView variant="title">Why are you reporting this?</TextView>
          <TextView
            variant="title"
            style={{ color: "#565556", fontWeight: 400 }}
          >
            We're dedicated to maintaining a respectful and safe community.
            Please let us know why you're reporting this content.
          </TextView>
        </>
      )}

      <Box>
        {options.map((option) => (
          <motion.div
            key={option.id}
            whileHover={{
              scale: 1.03,
              backgroundColor: "#EFE9FE",
              transition: { duration: 0.3 },
              borderRadius: "8px",
            }}
            whileTap={{
              scale: 0.97,
              transition: { duration: 0.3 },
            }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
              padding: "12px 16px",
              borderBottom: "1px solid #E1E1E1",
            }}
            onClick={() => onSelectOption(option)}
          >
            <TextView variant="subtitle" style={{ color: "#123051" }}>
              {option.name}
            </TextView>
            <ChevronRightIcon sx={{ color: "#212529" }} />
          </motion.div>
        ))}
      </Box>
    </>
  );
};

export default ReportOptions;
